import { createSelector } from 'reselect';
import property from 'lodash/property';
import getLogisticsState from './getLogisticsState';

export default (dialogName: string) => createSelector(
  getLogisticsState,
  property(['dialogs', dialogName]),
);
